import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/Button';
import useUpdateProvidedJobPostList from '../api/useUpdateProvidedJobPostList';
import { showSuccessToast } from '@/features/agent/job_change_processes/lib/toast';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  listId: string;
  currentName: string;
}

export default function RenameListDialog({ open, onOpenChange, listId, currentName }: Props) {
  const [name, setName] = useState(currentName);
  const { mutateAsync: updateList, isPending } = useUpdateProvidedJobPostList();

  useEffect(() => {
    if (open) setName(currentName);
  }, [open, currentName]);

  const handleSubmit = async () => {
    const trimmedName = name.trim();
    if (!trimmedName) return;
    try {
      await updateList({ id: listId, name: trimmedName });
      onOpenChange(false);
      showSuccessToast(`「${trimmedName}」を保存しました`);
    } catch {
      alert('リスト名の変更に失敗しました');
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[480px] rounded-sm">
        <DialogHeader>
          <DialogTitle>リスト名を変更</DialogTitle>
        </DialogHeader>

        <div className="p-lg">
          <label htmlFor="rename-list-name" className="mb-xs block text-sm font-bold">
            リスト名
          </label>
          <input
            id="rename-list-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="リスト名を入力してください"
            maxLength={15}
            className="w-[240px] rounded-sm border border-solid border-border px-3 py-2 text-sm focus:border-primary focus:outline-hidden"
            autoFocus
          />
        </div>

        <DialogFooter>
          <div className="flex gap-2">
            <Button color="secondary" size="md" onClick={() => onOpenChange(false)}>
              キャンセル
            </Button>
            <Button
              color="primary"
              size="md"
              onClick={handleSubmit}
              disabled={!name.trim() || isPending}
            >
              {isPending ? '保存中...' : '保存'}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
